<template>
  <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" :width="700">
    <div>
      <a-form class="flex-form form-label-5" :form="modal.form" :colon="false" layout="inline">
        <a-form-item label="收件人" required>
          <a-input
            v-decorator="[
              'person',
              {
                rules: [{ required: true, message: '请输入' }],
              },
            ]"
            placeholder="请输入姓名"
          ></a-input>
        </a-form-item>
        <a-form-item label="联系电话" required>
          <a-input
            v-decorator="[
              'phoneNumber',
              {
                rules: [
                  { required: true, message: '请输入' },
                  { pattern: Reg.isMobile, message: '请输入正确的手机号' },
                ],
              },
            ]"
            placeholder="请填写手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="地址">
          <v-distpicker
            @selected="selected"
            :province="address.province"
            :city="address.city"
            :area="address.region"
          ></v-distpicker>
          <a-input
            v-decorator="[
              'address',
              {
                rules: [{ required: true, message: '请输入' }],
              },
            ]"
            placeholder="请填写详细地址"
          ></a-input>
        </a-form-item>
        <a-button @click="setAddress">使用填写过的地址</a-button>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import VDistpicker from '@/components/Distpicker/Distpicker'
import { toolMixin } from '@/utils/mixin'
import Reg from '@/utils/reg'
export default {
  mixins: [toolMixin],
  components: {
    VDistpicker,
  },
  data() {
    return {
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '',
        data: {},
      },
      obj: null,
      address: {
        province: '',
        city: '',
        region: '',
      },
      Reg,
    }
  },
  methods: {
    setAddress() {
      this.modal.form.setFieldsValue({
        province: this.obj.province,
        city: this.obj.city,
        region: this.obj.region,
        address: this.obj.address,
        phoneNumber: this.obj.phoneNumber,
        person: this.obj.supplierCompanyName,
      })
      this.address.province = this.obj.province
      this.address.city = this.obj.city
      this.address.region = this.obj.region
    },
    async start(row, obj) {
      this.reset$t()
      this.obj = obj
      this.modal.visible = true
      this.modal.title = `${row.productName}收件地址`
      this.modal.data = { ...row }
      this.safeSetFieldsValue$t(this.modal.form, { ...row })
      this.address = {
        province: row.province,
        city: row.city,
        region: row.region,
      }
      return new Promise((resolve, reject) => {
        this.$once('end', function(state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      if (!(this.address.province && this.address.city && this.address.region)) {
        return this.$message.error('请选择省市区')
      }
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          this.$emit('end', 'ok', { productId: this.modal.data.productId, ...params, ...this.address })
        }
      })
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
    selected(data) {
      this.address.province = data.province.value
      this.address.city = data.city.value
      this.address.region = data.area.value
    },
  },
}
</script>

<style></style>
